<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellPercentNewPatientsOnScit',
    extends: TableCellBase,
    data() {
      return {
        fields: [
          'num_new_patients_scit',
          'num_new_patients_slit',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        const totalPatients = lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
        return this.round(this.getRatio(parseInt(this.monthObj['num_new_patients_scit']),  totalPatients), 2);
      },
    },
  };
</script>
